import React from "react";
import { Route } from "react-router-dom";
import { paths } from "./SnDraftRoutes";
import loadableModule from "spark-views/main/loadableModule";

const SnDraft = loadableModule(() => import('./index.js'));
const SnDraftRoute = () => (
    <Route path={paths.root} component={SnDraft} />
);

export default SnDraftRoute;